import { render, staticRenderFns } from "./products.vue?vue&type=template&id=34ed6bc3&scoped=true&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"
import style0 from "./products.vue?vue&type=style&index=0&id=34ed6bc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ed6bc3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TidalHeader: require('/app/node_modules/@tidal/styles-header/src/components/tidal-header.vue').default,ProductDetails: require('/app/app/components/productDetails.vue').default,TidalTab: require('/app/node_modules/@tidal/styles-tabs/src/components/tidal-tab.vue').default,TidalTabs: require('/app/node_modules/@tidal/styles-tabs/src/components/tidal-tabs.vue').default,TidalFooter: require('/app/node_modules/@tidal/styles-footer/src/components/tidal-footer.vue').default})
